<template>
  <base-card
    ><div v-if="isLoggedIn" class="card">
      <Toast />
      <form @submit.prevent="save">
        <Toolbar>
          <template v-slot:right>
            <Button
              label="Guardar"
              icon="pi pi-save"
              type="submit"
              @click="submitForm()"
              class="p-button-raised p-button-rounded"
            />
          </template>
        </Toolbar>
        <Divider align="left">
          <div class="p-d-inline-flex p-ai-center">
            <i class="pi pi-id-card p-mr-1"></i>
            <h3>Datos</h3>
          </div>
        </Divider>
        <div class="p-formgroup-inline">
          <div class="form-control" :class="{ invalid: !nombre.isValida }">
            <span class="p-float-label">
              <InputText
                id="nombre"
                type="text"
                @blur="clearValidity('nombre')"
                :maxlength="100"
                size="53"
                v-model="nombre.val"
              />
              <label for="nombre">Nombre</label>
            </span>
          </div>
        </div>
        <div><br /></div>
        <div class="p-formgroup-inline">
          <div class="form-control" :class="{ invalid: !usuario_upd.isValida }">
            <span class="p-float-label">
              <InputText
                id="usuario"
                type="text"
                @blur="clearValidity('usuario')"
                :maxlength="100"
                disabled="true"
                size="53"
                v-model="usuario_upd.val"
              />
              <label for="usuario">Usuario</label>
            </span>
          </div>
        </div>
        <div><br /></div>
        <div class="p-formgroup-inline">
          <div></div>
          <div class="form-control">
            <span class="p-float-label">
              <Password
                id="password"
                v-model="password.val"
                @input="validatePassword"
                :maxlength="50"
                size="50"
                toggleMask
                :feedback="false"
              />
              <label for="password">Contraseña</label>
            </span>
            <small v-if="password.error" class="p-error">{{
              password.error
            }}</small>
          </div>
          <div></div>
        </div>
        <div><br /></div>
        <div class="p-formgroup-inline">
          <div class="p-formgroup-inline">
            <div
              class="form-control"
              :class="{ invalid: !dispositivo.isValida }"
            >
              <span class="p-float-label">
                <InputText
                  id="dispositivo"
                  type="text"
                  @blur="clearValidity('dispositivo')"
                  :maxlength="50"
                  size="53"
                  v-model="dispositivo.val"
                />
                <label for="dispositivo">ID del dispositivo</label>
              </span>
            </div>
          </div>
        </div>
      </form>
    </div></base-card
  >
</template>

<script>
export default {
  props: ['usuario'],
  data() {
    return {
      formIsValida: true,
      error: null,
      usuario_upd: { val: '', isValida: true },
      nombre: { val: '', isValida: true },
      estatus: { val: '', isValida: true },
      password: { val: '', isValida: true, error: null },
      dispositivo: { val: '', isValida: true },
    };
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
    //console.log('yo primero 2');
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  created() {
    this.laodvaluesUsuario();
  },
  methods: {
    async laodvaluesUsuario() {
      try {
        this.usuarios = await this.$store.dispatch('loadUsuarios');

        for (const key in this.usuarios) {
          if (this.usuarios[key].usuario === this.usuarios[key].usuario) {
            this.usuario_upd.val = this.$route.params.usuario;
            this.nombre.val = this.usuarios[key].nombre;
            this.dispositivo.val = this.usuarios[key].dispositivo;
          }
        }
      } catch (error) {
        this.error = error.message || 'algo salió mal';
      }
    },
    clearValidity(input) {
      this[input].isValida = true;
    },
    async submitForm() {
      this.validForm();

      if (!this.formIsValida) {
        this.$toast.add({
          severity: 'error',
          summary: 'Campos Incorrectos',
          detail: 'Por favor revisar que los campos se encuentren correctos',
          life: 3000,
        });
        return;
      }
      const dataUser = {
        usuario: this.usuario_upd.val,
        nombre: this.nombre.val,
        password: this.password.val,
        estatus: '1',
        dispositivo: this.dispositivo.val,
      };
      console.log(dataUser);
      const response = await this.$store.dispatch('Usuariosupd', dataUser);
      console.log(response);
      if (response[0].codigo == 1) {
        this.$toast.add({
          severity: 'success',
          summary: 'Usuario agreado ',
          detail: response[0].mensaje,
          //group: 'br',
          life: 2000,
        });
        setTimeout(() => {
          this.$router.replace('/usuarios');
        }, 1000);
      } else {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: response[0].mensaje,
          //group: 'br',
          life: 2000,
        });
      }
    },
    validForm() {
      this.formIsValida = true;
      if (this.nombre.val === '') {
        this.formIsValida = false;
        this.nombre.isValida = false;
      }
      if (this.usuario_upd.val === '') {
        this.formIsValida = false;
        this.usuario_upd.isValida = false;
      }
      if (this.dispositivo.val === '') {
        this.formIsValida = false;
        this.dispositivo.isValida = false;
      }
      if (this.password.val === '') {
        this.formIsValida = false;
        this.password.isValida = false;
      }
    },
    validatePassword() {
      const regex =
        /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
      if (!regex.test(this.password.val)) {
        this.password.error =
          'La contraseña debe tener al menos 8 caracteres, incluir una mayúscula, un número y un carácter especial.';
      } else {
        this.password.error = null; // Sin error
      }
    },
    handleSubmit() {
      if (!this.password.error && this.password.val) {
        console.log('Contraseña válida:', this.password.val);
        // Aquí puedes enviar el formulario
      } else {
        console.error('Contraseña inválida.');
      }
    },
  },
};
</script>
